import { IColumn } from '../components/import/validators/abstract-validator.interface'
import {
  DataValidatorAadharNumber,
  DataValidatorBankAccountNumber,
  DataValidatorEmail,
  DataValidatorIFSCcode,
  DataValidatorMobileNumber,
  DataValidatorPFNumber,
  DataValidatorPanNumber,
  DataValidatorPincode,
  DataValidatorRequired,
  DataValidatorForMaritalStatus,
  DataValidatorUANNumber,
  DataValidatorForEmployementType,
  DataValidatorForNomineeRelationship,
  DateValidatorForFutureDate,
  DataValidatorForGender,
  DataValidatorForEmployeeStatus,
  DataValidatorForNationality,
  DataValidatorForNotificationPreferences,
  DataValidatorForDDMMYYYY,
  DataValidatorForYesNo,
  DataValidatorForYesNoCaseInsensitive,
  DataValidatorForTwoDecimalNumber,
  DataValidatorForFirstLetterCaps,
  DataValidatorForPassportNumber,
  DataValidatorESINumber,
  DataValidatorForAlphabetsOnly
} from '../components/import/validators/validator.functions'
import { sortList } from '../utils/sort.util'

export const ENTITY_ID: IColumn = {
  column: 'Entity ID',
  key: 'companyEntityDisplayId',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const CATEGORY: IColumn = {
  column: 'Category',
  key: 'taskCategory',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const ACTIVITY_NAME: IColumn = {
  column: 'Activity Name',
  key: 'name',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  customStyle: { 'min-width': '15.6rem' },
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const ACTIVITY_TYPE: IColumn = {
  column: 'Activity Type',
  key: 'activityType',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const EMPLOYEE_CODE: IColumn = {
  column: 'Employee Code',
  key: 'employeeCode',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DESCRIPTION: IColumn = {
  column: 'Description',
  key: 'description',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DOCUMENT_NAMES: IColumn = {
  column: 'Document Names',
  key: 'documents',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DISPLAY_ID: IColumn = {
  column: 'Display ID',
  key: 'displayId',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const QUERY_NAME: IColumn = {
  column: 'Name',
  key: 'name',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  customStyle: { 'min-width': '15.6rem' },
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DISPLAY_DESCRIPTION: IColumn = {
  column: 'Display Description',
  key: 'displayDescription',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const TASK_DUE_DATE: IColumn = {
  column: 'Task Due Date',
  key: 'dueDatetime',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const CALENDAR_DISPLAY_FOR: IColumn = {
  column: 'Display for',
  key: 'displayFor',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const CALENDAR_DISPLAY_TASK_FROM: IColumn = {
  column: 'Display task from',
  key: 'displayFromDatetime',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const CALENDAR_DISPLAY_TASK_TILL: IColumn = {
  column: 'Display Task till',
  key: 'displayToDatetime',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const SEND_NOTIFICATION: IColumn = {
  column: 'Send Notification',
  key: 'notify',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const EMP_DISPLAY_ID: IColumn = {
  column: 'Display ID',
  key: 'companyEntityDisplayId',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const EMPLOYEE_ID: IColumn = {
  column: 'Employee ID',
  key: 'employeeCode',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const MARITAL_STATUS: IColumn = {
  column: 'Marital Status',
  key: 'maritalStatus',
  validations: [DataValidatorForMaritalStatus()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PRIMARY_EMAIL_ID: IColumn = {
  column: 'Primary Email ID',
  key: 'emailId',
  validations: [DataValidatorRequired(), DataValidatorEmail()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const SECONDARY_EMAIL_ID: IColumn = {
  column: 'Secondary Email ID',
  key: 'secondaryEmailId',
  validations: [DataValidatorEmail()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PRIMARY_MOBILE_NUMBER: IColumn = {
  column: 'Primary Mobile Number',
  key: 'mobileNumber',
  validations: [DataValidatorMobileNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const SECONDARY_MOBILE_NUMBER: IColumn = {
  column: 'Secondary Mobile Number',
  key: 'alternateMobileNumber',
  validations: [DataValidatorMobileNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const AADHAR_NUMBER: IColumn = {
  column: 'Aadhaar Number',
  key: 'Aadhaar',
  validations: [DataValidatorAadharNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const AADHAAR_NAME: IColumn = {
  column: 'Aadhaar Name',
  key: 'nameInAadhaar',
  validations: [DataValidatorForFirstLetterCaps()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PAN_NUMBER: IColumn = {
  column: 'Pan Number',
  key: 'panNumber',
  validations: [DataValidatorPanNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PAN_NAME: IColumn = {
  column: 'Pan Name',
  key: 'nameInPAN',
  validations: [DataValidatorForFirstLetterCaps()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const NOMINEE_NAME: IColumn = {
  column: 'Nominee Name',
  key: 'nomineeName',
  validations: [DataValidatorForFirstLetterCaps()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const NOMINEE_RELATIONSHIP: IColumn = {
  column: 'Nominee Relationship',
  key: 'nomineeRelationship',
  validations: [DataValidatorForNomineeRelationship()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const NOMINEE_DOB: IColumn = {
  column: 'Nominee DOB',
  key: 'nomineeDob',
  validations: [DateValidatorForFutureDate(), DataValidatorForDDMMYYYY()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const UAN_NUMBER: IColumn = {
  column: 'UAN Number',
  key: 'uanNumber',
  validations: [DataValidatorUANNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PF_NUMBER: IColumn = {
  column: 'PF Number',
  key: 'pfNumber',
  validations: [DataValidatorPFNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const BANK_ACCOUNT_NUMBER: IColumn = {
  column: 'Bank Account number',
  key: 'accountNumber',
  validations: [DataValidatorBankAccountNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const IFSC_CODE: IColumn = {
  column: 'IFSC Code',
  key: 'ifscCode',
  validations: [DataValidatorIFSCcode()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const INTERNATIONAL_WORKER: IColumn = {
  column: 'Is International Worker',
  key: 'internationalWorker',
  validations: [DataValidatorForYesNo()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PASSPORT_NUMBER: IColumn = {
  column: 'Passport Number',
  key: 'passportNumber',
  validations: [DataValidatorForPassportNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PASSPORT_VALIDITY_FROM: IColumn = {
  column: 'Passport Validity From',
  key: 'passportValidFrom',
  validations: [DataValidatorForDDMMYYYY()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PASSPORT_VALIDITY_TO: IColumn = {
  column: 'Passport Validity To',
  key: 'passportExpiry',
  validations: [DataValidatorForDDMMYYYY()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const COUNTRY_OF_ISSUE: IColumn = {
  column: 'Country Of Issue',
  key: 'passportCountryOfIssue',
  validations: [DataValidatorForAlphabetsOnly()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PHYSICALLY_HANDICAP: IColumn = {
  column: 'Is Physically Disabled',
  key: 'physicallyHandicap',
  validations: [DataValidatorForYesNo()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const BASIC_WAGES: IColumn = {
  column: 'Basic Wages',
  key: 'basicWages',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DATE_OF_JOINING_IN_EPF: IColumn = {
  column: 'Date Of Joining In EPF',
  key: 'dojInEPF',
  validations: [DataValidatorForDDMMYYYY()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DATE_OF_LEAVING: IColumn = {
  column: 'Date Of Leaving',
  key: 'dol',
  validations: [DataValidatorForDDMMYYYY()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const EPF_APPLICABILITY: IColumn = {
  column: 'EPF Applicability',
  key: 'epfApplicability',
  validations: [DataValidatorForYesNo()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const EPS_APPLICABILITY: IColumn = {
  column: 'EPS Applicability',
  key: 'epsApplicability',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const GROSS_WAGES: IColumn = {
  column: 'Gross Wages',
  key: 'grossWages',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DOOR_NO: IColumn = {
  column: 'Door No',
  key: 'doorno',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const STREET: IColumn = {
  column: 'Street',
  key: 'street',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const AREA: IColumn = {
  column: 'Area',
  key: 'area',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const CITY: IColumn = {
  column: 'City',
  key: 'city',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const STATE: IColumn = {
  column: 'State',
  key: 'state',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const COUNTRY: IColumn = {
  column: 'Country',
  key: 'country',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PINCODE: IColumn = {
  column: 'PinCode',
  key: 'pin',
  validations: [DataValidatorPincode()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DOB: IColumn = {
  column: 'DOB',
  key: 'dob',
  validations: [DataValidatorRequired(), DateValidatorForFutureDate(), DataValidatorForDDMMYYYY()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DATE_OF_JOINING: IColumn = {
  column: 'Joining Date',
  key: 'doj',
  validations: [DataValidatorRequired(), DateValidatorForFutureDate(), DataValidatorForDDMMYYYY()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const FIRST_NAME: IColumn = {
  column: 'First Name',
  key: 'firstName',
  validations: [DataValidatorRequired(), DataValidatorForFirstLetterCaps()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const MIDDLE_NAME: IColumn = {
  column: 'Middle Name',
  key: 'middleName',
  validations: [DataValidatorForFirstLetterCaps()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const LAST_NAME: IColumn = {
  column: 'Last Name',
  key: 'lastName',
  validations: [DataValidatorRequired(), DataValidatorForFirstLetterCaps()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const EMPLOYEE_TYPE: IColumn = {
  column: 'Type Of Employee',
  key: 'typeOfEmployment',
  validations: [DataValidatorRequired(), DataValidatorForEmployementType()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DEPARTMENT: IColumn = {
  column: 'Department',
  key: 'departmentName',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const BRANCH: IColumn = {
  column: 'Branch',
  key: 'branch',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const LOCATION: IColumn = {
  column: 'Location',
  key: 'location',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const GENDER: IColumn = {
  column: 'Gender',
  key: 'gender',
  validations: [DataValidatorRequired(), DataValidatorForGender()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const NATIONALITY: IColumn = {
  column: 'Nationality',
  key: 'nationality',
  validations: [DataValidatorForNationality()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const RESPONSE_DUE_BY: IColumn = {
  column: 'Response Due By',
  key: 'responseDueBy',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  customStyle: { 'min-width': '15.6rem' },
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const CURRENT_PF_ACCOUNT_NUMBER: IColumn = {
  column: 'Current PF Account Number',
  key: 'currentPFAccountNumber',
  validations: [DataValidatorPFNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const QUERY_DISPLAY_ID: IColumn = {
  column: 'Query ID',
  key: 'displayId',
  validations: [DataValidatorRequired()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const STATUS: IColumn = {
  column: 'Status',
  key: 'status',
  validations: [DataValidatorRequired(), DataValidatorForEmployeeStatus()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const CATEGORY_OF_QUERY: IColumn = {
  column: 'Category of Query',
  key: 'queryCategory',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PRIORITY_LEVEL: IColumn = {
  column: 'Priority Level',
  key: 'priority',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const NEXT_INTERNAL_DUE_DATE: IColumn = {
  column: 'Next Internal Due Date',
  key: 'nextInternalDueDate',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DEPT_TIMELINE: IColumn = {
  column: 'Dept Timeline',
  key: 'epfoTimeline',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const ASSIGN_TO: IColumn = {
  column: 'Assign To',
  key: 'assignedToDisplayId',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const TAG: IColumn = {
  column: 'Tag',
  key: 'tag',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const NOTES: IColumn = {
  column: 'Notes',
  key: 'notes',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PASSPORT_NAME: IColumn = {
  column: 'Passport Name',
  key: 'passportName',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DESIGNATION: IColumn = {
  column: 'Designation',
  key: 'designation',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const HIGHER_PENSION_APPLICABILITY: IColumn = {
  column: 'Higher Pension Applicability',
  key: 'higherPensionApplicability',
  validations: [DataValidatorForYesNo()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const FATHER_NAME: IColumn = {
  column: 'Father Name',
  key: 'fatherName',
  validations: [DataValidatorForFirstLetterCaps()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const ROLE_CODE: IColumn = {
  column: 'Role Code',
  key: 'roleCode',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PENSION_PAYMENT_ORDER_NUMBER: IColumn = {
  column: 'Pension Payment Order Number',
  key: 'pensionPaymentOrderNumber',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYMENT: IColumn = {
  column: 'Date Of Exit From Previous Employment',
  key: 'dateOfExitFromPreviousEmployer',
  validations: [DataValidatorForDDMMYYYY()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const ESI_NUMBER: IColumn = {
  column: 'ESI Number',
  key: 'esiNumber',
  validations: [DataValidatorESINumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const MONTH_WORKING_DAYS: IColumn = {
  column: 'Month-Working Days',
  key: 'monthWorkingDays',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}
export const WORKED_DAYS: IColumn = {
  column: 'Worked Days',
  key: 'workedDays',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const BASIC_PAY: IColumn = {
  column: 'Basic Pay',
  key: 'basicPay',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const HRA: IColumn = {
  column: 'HRA',
  key: 'hra',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const LTA: IColumn = {
  column: 'LTA',
  key: 'lta',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const PERQ_ALLOWANCE: IColumn = {
  column: 'Perq Allowance',
  key: 'perquisiteAllowance',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const SPECIAL_ALLOWANCE: IColumn = {
  column: 'Special Allowance',
  key: 'specialAllowance',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const TELEPHONE_ALLOWANCE: IColumn = {
  column: 'Telephone Allowance',
  key: 'telephoneAllowance',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const FOOD_ALLOWANCE: IColumn = {
  column: 'Food Allowance',
  key: 'foodAllowance',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const GROSS_EARNINGS: IColumn = {
  column: 'Gross Earnings',
  key: 'grossEarnings',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const LOP: IColumn = {
  column: 'LOP',
  key: 'lop',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const TDS: IColumn = {
  column: 'TDS',
  key: 'tds',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const EPS: IColumn = {
  column: 'EPS',
  key: 'eps',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const ADVANCE_PAY: IColumn = {
  column: 'Advance Pay',
  key: 'advancePay',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const SALARY_DUE_NET_SALARY: IColumn = {
  column: 'Salary Due (Net Salary)',
  key: 'salaryDue',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const NATURE_OF_WORK: IColumn = {
  column: 'Nature of work',
  key: 'natureOfWork',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const DAILY_HOURS_OF_WORK: IColumn = {
  column: 'Daily hours of work',
  key: 'dailyHoursOfWork',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const INTERVALS_OF_REST: IColumn = {
  column: 'Intervals of rest',
  key: 'intervalsOfRest',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const OVERTIME_WAGES: IColumn = {
  column: 'Overtime Wages',
  key: 'overtimeWages',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const EPF_WAGES_ON_JOINING: IColumn = {
  column: 'EPF Wages On Joining',
  key: 'epfWageAsOnJoining',
  validations: [DataValidatorForTwoDecimalNumber()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const REASON_FOR_LEAVING: IColumn = {
  column: 'Reason For Leaving',
  key: 'reasonForLeaving',
  validations: [],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const SPOUSE_NAME: IColumn = {
  column: 'Spouse Name',
  key: 'spouseName',
  validations: [DataValidatorForFirstLetterCaps()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const NOTIFICATION_PREFERENCES: IColumn = {
  column: 'Notification Preferences',
  key: 'notificationPreferences',
  validations: [DataValidatorForNotificationPreferences()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const SCHEME_CERTIFICATE_NUMBER: IColumn = {
  column: 'Scheme Certificate Number',
  key: 'schemeCertificateNumber',
  validations: [],
  isFilterable: false,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const MAIL_TRIGGER: IColumn = {
  column: 'Mail Trigger',
  key: 'triggerWelcomeMail',
  validations: [DataValidatorRequired(), DataValidatorForYesNoCaseInsensitive()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}

export const NEW_JOINER_ACTIVITY: IColumn = {
  column: 'New Joiner Activity',
  key: 'triggerNewJoineeActivity',
  validations: [DataValidatorForYesNoCaseInsensitive()],
  isFilterable: true,
  sortFn: (listToSort: any[], column: IColumn, direction: 'ASC' | 'DESC') =>
    sortList(listToSort, direction, column.column)
}
